var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _circle5, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgActivityError = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 212,
  height: 240,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 63,
  width: 144,
  height: 177,
  rx: 8,
  fill: "#DAE0FF"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 64,
  y: 15,
  width: 146,
  height: 177,
  rx: 8,
  stroke: "#DAE0FF",
  strokeWidth: 2,
  strokeMiterlimit: 1,
  strokeLinecap: "round",
  strokeDasharray: "8 12"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M32 47C32 42.5817 35.5817 39 40 39H150C154.418 39 158 42.5817 158 47V146C158 184.66 126.66 216 88 216H40C35.5817 216 32 212.418 32 208V47Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.5 60C49.5 59.7239 49.2761 59.5 49 59.5C48.7239 59.5 48.5 59.7239 48.5 60L49.5 60ZM48.5 198C48.5 198.276 48.7239 198.5 49 198.5C49.2761 198.5 49.5 198.276 49.5 198L48.5 198ZM48.5 60L48.5 198L49.5 198L49.5 60L48.5 60Z",
  fill: "#EAEAEF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M94 66C95.6569 66 97 64.6569 97 63C97 61.3431 95.6569 60 94 60V66ZM58 60C56.3431 60 55 61.3431 55 63C55 64.6569 56.3431 66 58 66V60ZM94 60L58 60V66H94V60Z",
  fill: "#EAEAEF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M109 84C110.657 84 112 82.6569 112 81C112 79.3431 110.657 78 109 78V84ZM58 78C56.3431 78 55 79.3431 55 81C55 82.6569 56.3431 84 58 84V78ZM109 78H58V84H109V78Z",
  fill: "#EAEAEF"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M125 102C126.657 102 128 100.657 128 99C128 97.3431 126.657 96 125 96V102ZM58 96C56.3431 96 55 97.3431 55 99C55 100.657 56.3431 102 58 102V96ZM125 96L58 96V102L125 102V96Z",
  fill: "#EAEAEF"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M92 120C93.6569 120 95 118.657 95 117C95 115.343 93.6569 114 92 114V120ZM58 114C56.3431 114 55 115.343 55 117C55 118.657 56.3431 120 58 120V114ZM92 114H58V120H92V114Z",
  fill: "#EAEAEF"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M109 138C110.657 138 112 136.657 112 135C112 133.343 110.657 132 109 132V138ZM58 132C56.3431 132 55 133.343 55 135C55 136.657 56.3431 138 58 138V132ZM109 132H58V138H109V132Z",
  fill: "#EAEAEF"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 188C33.1016 188 34 187.102 34 186C34 184.898 33.1016 184 32 184C30.8984 184 30 184.898 30 186C30 187.102 30.8984 188 32 188Z",
  fill: "#282863"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M157 68C155.898 68 155 68.8977 155 70C155 71.1016 155.898 72 157 72C158.102 72 159 71.1016 159 70C159 68.8977 158.102 68 157 68Z",
  fill: "#282863"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 135,
  r: 2.5,
  fill: "#EAEAEF",
  stroke: "#EAEAEF"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 117,
  r: 2.5,
  fill: "#EAEAEF",
  stroke: "#EAEAEF"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 99,
  r: 2.5,
  fill: "#EAEAEF",
  stroke: "#EAEAEF"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 81,
  r: 2.5,
  fill: "#EAEAEF",
  stroke: "#EAEAEF"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 63,
  r: 2.5,
  fill: "#EAEAEF",
  stroke: "#EAEAEF"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M32 178V50.5C32 46.0817 35.5817 42.5 40 42.5H149.5C153.918 42.5 157.5 46.0817 157.5 50.5V62",
  stroke: "#282863",
  strokeWidth: 4,
  strokeLinecap: "round"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M32 193.5C32 196.273 32 201.514 32 206.002C32 210.42 35.5817 214 40 214H116.255C118.306 214 120.28 213.212 121.767 211.798L154.512 180.668C156.101 179.158 157 177.062 157 174.87V77",
  stroke: "#282863",
  strokeWidth: 4,
  strokeLinecap: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M120.183 212.428L154.647 180.231C155.31 179.611 154.872 178.5 153.965 178.5H137.5H122.5C120.291 178.5 118.5 180.291 118.5 182.5V211.697C118.5 212.572 119.544 213.025 120.183 212.428Z",
  stroke: "#282863",
  strokeWidth: 4,
  strokeLinecap: "round"
})));
export default SvgActivityError;